module.exports = __webpack_public_path__ + "static/img/Lable_02.3ed444f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Lable_02.png
// module id = nZqN
// module chunks = 1